"use client";

import { useTranslations } from "next-intl";
import { Button } from "./button";
import { cn } from "@/lib/utils";

// Paginador ÚNICO de la plataforma. Antes estaba copiado casi igual en CrudTable, Dashboard,
// Informes y los históricos de puntos/dispositivos (selector de filas + rango + Anterior/Siguiente),
// cada uno con pequeñas diferencias. Aquí queda uno solo para que todas las listas paginen igual.
export const PAGE_SIZES = [10, 20, 50, 100];

export function Pagination({
  page,
  pageSize,
  total,
  onPage,
  onPageSize,
  className,
}: {
  page: number;
  pageSize: number;
  total: number;
  onPage: (p: number) => void;
  onPageSize: (n: number) => void;
  className?: string;
}) {
  const t = useTranslations("common");
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const current = Math.min(page, pages - 1);

  return (
    <div
      className={cn(
        "mt-4 flex flex-wrap items-center justify-between gap-3 text-sm text-muted-foreground",
        className,
      )}
    >
      <div className="flex items-center gap-2">
        <span>{t("filasPorPagina")}</span>
        <select
          className="h-8 rounded-md border border-input bg-transparent px-2"
          value={pageSize}
          onChange={(e) => onPageSize(Number(e.target.value))}
        >
          {PAGE_SIZES.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
      </div>
      <div className="flex items-center gap-3">
        <span>
          {t("rango", {
            desde: total === 0 ? 0 : current * pageSize + 1,
            hasta: Math.min((current + 1) * pageSize, total),
            total,
          })}
        </span>
        <Button variant="ghost" size="sm" disabled={current === 0} onClick={() => onPage(current - 1)}>
          {t("anterior")}
        </Button>
        <Button variant="ghost" size="sm" disabled={current >= pages - 1} onClick={() => onPage(current + 1)}>
          {t("siguiente")}
        </Button>
      </div>
    </div>
  );
}
